module.exports = __webpack_public_path__ + "static/media/Green_dot.32aefb53.png";